module.exports = __webpack_public_path__ + "img/platinum-card-no-logo.a713b92d.png";